import Feature from 'components/feature/Feature';
import React from 'react';

const FeatureTab = () => {
  return (
    <div>
      <Feature/>
    </div>
  );
};

export default FeatureTab;
